import { inject, Injectable } from '@angular/core';
import { DialogService } from '@vectronic/util';
import { filter, map, Observable } from 'rxjs';
import { ConfirmationDialogComponent } from '../modals/confirmation-dialog/confirmation-dialog.component';
import { InformationDialogComponent } from '../modals/information-dialog/information-dialog.component';

@Injectable({ providedIn: 'root' })
export class DialogUtilService {
  private readonly dialogService = inject(DialogService);

  confirm(message: string, useMonospaceFont?: boolean): Observable<boolean> {
    return this.dialogService
      .open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirm',
          message,
          useMonospaceFont,
        },
      })
      .afterClosed();
  }

  whenConfirmed(message: string, useMonospaceFont?: boolean): Observable<void> {
    return this.confirm(message, useMonospaceFont).pipe(
      filter(Boolean),
      map(() => undefined),
    );
  }

  error(message: string): void {
    this.dialogService.open(InformationDialogComponent, {
      data: {
        text: message,
        title: 'Error',
      },
    });
  }
}
